<template>
<div id="gridSystemModal" class="modal fade in" tabindex="-1" role="dialog"
 aria-labelledby="gridModalLabel"
  style="display: block; padding-right: 17px;background: rgba(0, 0, 0, 0.4);">
    <div class="modal-dialog" role="document" :style='pwidth'>
        <div class="modal-content">
            <div class="modal-header" style="padding: 0 15px">
                <button @click.stop="close" type="button" class="close"
                 data-dismiss="modal" aria-label="Close" style="margin-top: 5px"><span aria-hidden="true" class="close-x">×</span></button>
                <h4><slot name="header"></slot></h4>
            </div>
            <div class="modal-body">
                <slot></slot>
            </div>
            <div class="modal-footer" style="padding: 10px 15px">
                <slot name="footer"></slot>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div>
</template>
  

<script>
export default {
    props:["width"],
    computed:{
        pwidth: function(){ 
            return "width: " + (this.width || "600px")
        }
    },
  methods: {
    close: function() {
      this.$emit("close");
    }
  }
};
//isFirst, isPre, isNext, isLast, isAdd, isExp, pageNo, pageCount, pageSize, rowCount
</script>